import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { jsxs, jsx } from 'react/jsx-runtime.js';
import { forwardRef, useCallback } from 'react';
import cn from 'classnames';
import styles from './Button.module.css.js';
export { default as styles } from './Button.module.css.js';

var _excluded = ["children", "className", "icon", "onClick", "size", "variant"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Button = /*#__PURE__*/forwardRef(function (props, ref) {
  var _cn;
  var children = props.children,
    className = props.className,
    icon = props.icon,
    onClick = props.onClick,
    _props$size = props.size,
    size = _props$size === void 0 ? 'L' : _props$size,
    variant = props.variant,
    restProps = _objectWithoutProperties(props, _excluded);
  var handleClick = useCallback(function (e) {
    if (onClick) {
      onClick(e);
    }
  }, [onClick]);
  return jsxs("button", _objectSpread(_objectSpread({
    className: cn(className, styles.qdButton, (_cn = {}, _defineProperty(_cn, styles.primary, variant === 'primary'), _defineProperty(_cn, styles.clear, variant === 'clear'), _defineProperty(_cn, styles.danger, variant === 'danger'), _defineProperty(_cn, styles.qdButton_small, size === 'S'), _defineProperty(_cn, styles.qdButton_large, size === 'L'), _cn)),
    onClick: handleClick,
    "data-qd-clickable": props['data-qd-clickable'],
    "data-qd-test": props['data-qd-test'],
    ref: ref
  }, restProps), {}, {
    children: [icon ? jsx("span", {
      className: styles.icon,
      children: icon
    }) : null, children]
  }));
});

export { Button };
